<template>
  <div class="card" @click="$emit('click')">
    <div class="left">
      <div class="name">
        {{name}}
      </div>
      <div class="employee">
        工号: {{employeeNo}}
      </div>
    </div>
    <div class="company">
      {{companyName}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    employeeNo: {
      type: String
    },
    companyName: {
      type: String
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/var'


.card
  height pt(230)
  background-color white
  margin pt(20)
  border-radius 20px
  depth(1)
  padding 0 pt(24)
  display flex
  justify-content space-between
  align-items center
  font-size $normal-font-size
  .left
    display flex
    flex-direction column
    justify-content flex-start
    min-width pt(170)
    .employee
      color $disable-text-color
  .company
    single-line()
</style>




// WEBPACK FOOTER //
// personal-info-card.vue?0ef058bf